import React, {useMemo, useState} from 'react'
import {useAuth} from "../../../providers/AuthProvider";
import SupplierFormItemProvider from "../providers/SupplierFormItemProvider";
import SupplierBrandForm from "./SupplierBrandForm";
import ProfileBrand from "../../profiles/components/ProfileBrand";
import {Alert} from "antd";

const SupplierBrandsStep = ({supplierOrg, onChange, onSave,...props}) => {

    const {auth} = useAuth()
    const [editingIndex, setEditingIndex] = useState(false);

    const addNewArrayProp = async (propName) => {

        let models = TB.get({...supplierOrg}, propName, []);
        models.push({
            is_custom: 0,
            brand: undefined
        });

        await onChange({[propName]: models});
        return setEditingIndex(models?.length - 1)
    }
    const getModelFromProps = (brand) => {

        let {
            ...model
        } = {...(brand || {})}

        return {...(brand || {})}
    }

    const validBrands = useMemo(() => {
        return TB.filter(supplierOrg?.brands, brand => !!brand?.id)
    }, [supplierOrg?.brands]);

    return (
        <div>
            <div className="form-title-section">
                <div className="step-title-content">
                    <div>
                        <div className="flex items-center pb-4">
                            <h3 className="form-title !mb-0">
                                Brands
                            </h3>

                            {/*{this.constructor.LastUpdatedMethod && this.renderLastUpdated(this.constructor.LastUpdatedMethod)}*/}
                        </div>


                        <h5 className="form-subtitle">
                            Showcase the brands you've worked with or have partnerships with.
                        </h5>
                    </div>
                    <Alert
                        message="At least 1 brand is required."
                           type={validBrands?.length > 0 ? 'success' : 'warning'}
                           style={{fontSize: 13, lineHeight: '14px'}}
                           className={TB.mapClass("[&>.ant-alert-icon]:mt-[-1px] mx-auto md:ml-auto md:mr-0", {
                               "border-[#FFB946]": !validBrands?.length,
                               "border-[#5ae399]": validBrands?.length > 0,
                           })}
                    />
                </div>
            </div>

            {TB.map(supplierOrg?.brands || [], (brandItem, brandIndex) => {

                const brand = getModelFromProps(brandItem);
                return (
                    <SupplierFormItemProvider
                        key={`brands-${brand.id}-${brandIndex}`}
                        itemIndex={brandIndex}
                        preview={<div className="px-4 flex flex-col jsutify-start">
                            <ProfileBrand brand={brand} showTooltip={true} className="max-w-[200px]"/>
                        </div>}
                        onChange={brandProps => {
                            let changedModel = TB.cloneDeep(brand);
                            for (let [key, value] of Object.entries(brandProps)) {
                                changedModel = TB.set(changedModel, key, value);
                            }

                            if (TB.isDefined(changedModel.is_custom) && brand.is_custom && !changedModel.is_custom) {
                                changedModel.name = undefined;
                                changedModel.logo = undefined;
                                changedModel.domain = undefined;

                            }else if(TB.isDefined(changedModel.is_custom) && !brand.is_custom && changedModel.is_custom) {
                                changedModel.brand = undefined;
                            }
                            return changedModel
                        }}
                        onSave={async (brandProps) => {

                            const formatPropsForRequest = brand => {
                                let formatted = TB.pick(brand, [
                                    'id',
                                    'name',
                                    'domain',
                                    'brand',
                                    'icon',
                                    'is_custom',
                                    'display_index',
                                ]);

                                return formatted
                            }
                            let model = {
                                ...brand,
                                ...brandProps,
                                ...(brandProps?.brand || {})
                            };

                            if (!brandProps) {
                                let brands = TB.filter([...supplierOrg?.brands], (brands, index) => {
                                    return brandIndex !== index;
                                });
                                if (brand?.id) {
                                    brands = TB.map(brands, brand => formatPropsForRequest(brand))
                                    return onSave({brands: brands}, true);
                                }

                                await onChange({brands: brands})
                            }else {
                                if (!model?.id || !model.display_index) {
                                    let lastBrand = TB.first(
                                        TB.orderBy(
                                            TB.filter([...supplierOrg?.brands], brand => TB.isDefined(brand.display_index)), 'display_index',
                                            'desc'
                                        ));
                                    if (!!lastBrand?.display_index) {
                                        model.display_index = lastBrand.display_index + 1;
                                    } else model.display_index = 1;
                                }
                                let brands = TB.set([...supplierOrg?.brands], brandIndex, model);

                                await onChange({brands: brands});
                                await setEditingIndex(false);
                                brands = TB.map(brands, brand => formatPropsForRequest(brand))

                                return onSave({brands: brands}, true);
                            }
                        }}
                        model={brand}
                        isUpdating={props.isUpdating}
                        canEdit={editingIndex === false}
                        isEditing={editingIndex === brandIndex}
                        onEditing={(toggle) => {
                            setEditingIndex(toggle ? brandIndex : false)
                        }}
                        deleteOnly={TB.isDefined(brand.id)}
                        displayName="Brand"
                        itemPropName="brands">

                        <SupplierBrandForm supplierOrg={supplierOrg}/>

                    </SupplierFormItemProvider>
                )
            })}

            <div
                className={'white-panel talent-role-panel ' + (!!editingIndex && 'no-edit')}>
                <button
                    disabled={false}
                    className="btn btn-outline-dark" onClick={() => addNewArrayProp('brands')}>

                    Add Brand #{(supplierOrg?.brands || [])?.length + 1} <i className="ml-1 fa fa-plus"/>
                </button>
            </div>
        </div>
    )
}
export default SupplierBrandsStep

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};